/**
 * OAuth provider callback route — eagerly registers the file route and its
 * `validateSearch` schema; the page component and its atom/RPC imports are
 * deferred to `$provider.lazy.tsx` so they load only with this route, never in
 * the always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { Schema } from "effect";

// Deliberately declares ONLY the params we consume. Discord's redirect also
// appends `guild_id` and `permissions`, which are all-digits — TanStack's search
// parser turns those into JS numbers, so declaring them as `Schema.String`
// throws and 500s the whole callback page. Undeclared keys are stripped by
// Effect, which is exactly what we want: the authoritative guild id comes from
// the token-exchange response server-side, never from the query string (the
// param is precision-damaged anyway — see `identifyDiscord`).
export const SearchSchema = Schema.Struct({
  code: Schema.optional(Schema.String),
  state: Schema.optional(Schema.String),
  error: Schema.optional(Schema.String),
});

export const Route = createFileRoute("/onboarding/oauth/callback/$provider")({
  validateSearch: Schema.decodeUnknownSync(SearchSchema),
});
